import { render, staticRenderFns } from "./BarCharttool.vue?vue&type=template&id=c31dae56"
import script from "./BarCharttool.vue?vue&type=script&lang=js"
export * from "./BarCharttool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports